import axios     from "__js__/axios";
import { store } from "__vue__/index";
import reverse   from "django-reverse";

export function fetchMapsCount(): Promise<number> {
  return axios.get(reverse("mapApi:mapsCount", store.state.language)).then(r => r.data.count);
}
